import { useTheme } from '@shopify/restyle';
import { IconCalendarOff } from '@tabler/icons-react-native';
import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { localeAwareFormat } from 'app/lib/date';
import type { Theme } from 'app/shopify';
import type { Loan } from 'app/types/loan';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { getClosestActivityMonth } from './loan-calendar-utils';

export function EmptyLoanPeriod({
  loans,
  month,
  onMonthChange,
}: {
  loans: Loan[];
  month: Date;
  onMonthChange: (date: Date) => void;
}) {
  const theme = useTheme<Theme>();
  const { t } = useTranslation('loans');
  const closestActivityMonth = getClosestActivityMonth(loans, month);

  return (
    <Column
      alignItems="center"
      backgroundColor="surface.primary-neutral"
      borderRadius="radius.lg"
      gap="spacing.general.x2"
      padding="spacing.general.x6"
    >
      <View
        style={{
          alignItems: 'center',
          backgroundColor: theme.colors['surface.secondary'],
          borderRadius: theme.borderRadii['radius.full'],
          height: 48,
          justifyContent: 'center',
          width: 48,
        }}
      >
        <IconCalendarOff color={theme.colors['surface.brand.strong']} size={24} strokeWidth={ICON_STROKE_WIDTH} />
      </View>
      <Text fontWeight="600" textAlign="center" variant="bodyLarge">
        {t('calendar.emptyPeriod.title')}
      </Text>
      <Text color="text.secondary" textAlign="center">
        {t('calendar.emptyPeriod.description')}
      </Text>
      {closestActivityMonth ? (
        <Button
          onPress={() => onMonthChange(closestActivityMonth)}
          style={{ marginTop: theme.spacing['spacing.general.x2'] }}
          variant="secondary"
        >
          {t('calendar.emptyPeriod.closestActivity', {
            month: localeAwareFormat(closestActivityMonth, 'MMMM y'),
          })}
        </Button>
      ) : null}
    </Column>
  );
}
